import { ThemeComponent } from '@geogirafe/lib-geoportal/components';
import CustomNewIcon from './images/new.png';
import MyCustomThemeIcon from './images/custom.png';

export default class MapbsThemeComponent extends ThemeComponent {
  public override newIcon: string = CustomNewIcon;

  public override get customThemes() {
    const themes = super.customThemes;
    Object.values(themes).forEach((theme) => {
      theme.icon = MyCustomThemeIcon;
    });
    return themes;
  }
}
